import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityLaboratoriosState } from './laboratorios.state';
import { entityLaboratoriosAdapter } from './laboratorios.state';
import {
  entityLaboratoriosLoadRequest,
  entityLaboratoriosLoadSuccess,
  entityLaboratoriosLoadFailure,
  entityLaboratoriosAddFailure,
  entityLaboratoriosAddRequest,
  entityLaboratoriosAddSuccess,
  entityLaboratoriosDeleteSuccess,
  entityLaboratoriosDeleteRequest,
  entityLaboratoriosDeleteFailure
} from './laboratorios.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityLaboratoriosLoadRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityLaboratoriosLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityLaboratoriosLoadSuccess, (state, { items }) =>
    entityLaboratoriosAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityLaboratoriosAddRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityLaboratoriosAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityLaboratoriosAddSuccess, (state, { item }) => {
    return entityLaboratoriosAdapter.upsertMany(item, {
      ...state,
      hasAddedSuccess: true,
      isLoading: false,
      error: null
    });
  }),

  // delete

  on(entityLaboratoriosDeleteRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),

  on(entityLaboratoriosDeleteFailure, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),

  on(entityLaboratoriosDeleteSuccess, (state, { item }) =>
    entityLaboratoriosAdapter.removeOne(item.id, {
      ...state,
      isLoading: false
    })
  )
);

export function laboratoriosReducer(
  state: EntityLaboratoriosState | undefined,
  action: Action
) {
  return reducer(state, action);
}
